import { LoadingDots } from "@/app/test/components/LoadingDots";
import { PageContainer } from "@/components/layout/PageContainer";
import { cn } from "@/components/libs/cn";
import { useSearchParams } from "@/shared/navigation/useNavigation";
import { testId } from "@/shared/test/tesId/testId";

interface LoaderProps {
  className?: string;
}

export function Loader({ className }: LoaderProps) {
  return (
    <LoadingDots className={className} data-testid={testId.components.loader} />
  );
}

export function FullPageLoader({ noLogo }: { noLogo?: boolean }) {
  const searchParams = useSearchParams();

  const isHidden = searchParams.has("noloader");

  return (
    <PageContainer
      heightScreen
      noLogo={noLogo}
      className={cn(isHidden && "invisible")}
    >
      <div className="flex flex-1 items-center justify-center">
        <Loader />
      </div>
    </PageContainer>
  );
}
